import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const PremiumLibraryIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <div data-testid="hiddenCursorIcon" style={{ display: "flex", justifyContent: "center" }}>
      <IconBase
        ref={ref}
        fill="none"
        renderPath={() => {
          return (
            <>
              <path
                d="M8 2L10.6667 6.7785L14 3.59283L12.6667 11.557H3.33333L2 3.59283L5.33333 6.7785L8 2Z"
                fill="#F5B53D"
                stroke="#F5B53D"
                strokeWidth="1.50415"
                strokeLinecap="round"
              />
            </>
          );
        }}
        viewBox="0 0 16 13"
        {...props}
      >
        {props.children}
      </IconBase>
    </div>
  );
});

PremiumLibraryIcon.displayName = "DownloadIcon";

export { PremiumLibraryIcon };
